import type { PaymentMethodCheckoutField } from '@checkout/core'

export interface BillingInformationValue {
  line1: string
  line2: string
  city: string
  country: string
  region: string
  postalCode: string
  cardholderName: string
  givenName: string
  familyName: string
  phoneNumber: string
}

export type BillingInformationFieldKind = 'input' | 'country' | 'region'

export interface BillingInformationFieldDefinition {
  field: PaymentMethodCheckoutField
  valueKey: keyof BillingInformationValue
  payloadKey:
    | 'line1'
    | 'line2'
    | 'city'
    | 'country'
    | 'state'
    | 'postal_code'
    | 'cardholder_name'
    | 'given_name'
    | 'family_name'
    | 'phone_number'
  labelKey: string
  autoComplete: string
  kind: BillingInformationFieldKind
}

export const BILLING_INFORMATION_FIELD_REGISTRY = [
  {
    field: 'given_name',
    valueKey: 'givenName',
    payloadKey: 'given_name',
    labelKey: 'billing.firstName',
    autoComplete: 'given-name',
    kind: 'input',
  },
  {
    field: 'family_name',
    valueKey: 'familyName',
    payloadKey: 'family_name',
    labelKey: 'billing.lastName',
    autoComplete: 'family-name',
    kind: 'input',
  },
  {
    field: 'cardholder_name',
    valueKey: 'cardholderName',
    payloadKey: 'cardholder_name',
    labelKey: 'billing.cardholderName',
    autoComplete: 'cc-name',
    kind: 'input',
  },
  {
    field: 'phone_number',
    valueKey: 'phoneNumber',
    payloadKey: 'phone_number',
    labelKey: 'customer.phone',
    autoComplete: 'tel',
    kind: 'input',
  },
  {
    field: 'billing_line1',
    valueKey: 'line1',
    payloadKey: 'line1',
    labelKey: 'billing.addressLine1',
    autoComplete: 'address-line1',
    kind: 'input',
  },
  {
    field: 'billing_line2',
    valueKey: 'line2',
    payloadKey: 'line2',
    labelKey: 'billing.addressLine2',
    autoComplete: 'address-line2',
    kind: 'input',
  },
  {
    field: 'billing_city',
    valueKey: 'city',
    payloadKey: 'city',
    labelKey: 'billing.city',
    autoComplete: 'address-level2',
    kind: 'input',
  },
  {
    field: 'billing_country',
    valueKey: 'country',
    payloadKey: 'country',
    labelKey: 'billing.country',
    autoComplete: 'country',
    kind: 'country',
  },
  {
    field: 'billing_region',
    valueKey: 'region',
    payloadKey: 'state',
    labelKey: 'billing.region',
    autoComplete: 'address-level1',
    kind: 'region',
  },
  {
    field: 'billing_postal_code',
    valueKey: 'postalCode',
    payloadKey: 'postal_code',
    labelKey: 'billing.postalCode',
    autoComplete: 'postal-code',
    kind: 'input',
  },
] as const satisfies readonly BillingInformationFieldDefinition[]

export const BILLING_INFORMATION_FIELDS = BILLING_INFORMATION_FIELD_REGISTRY.map(
  (definition) => definition.field
)
